import { api } from '../lib/api'
import type { Listing } from './store'

export type ListingsPage = { results: Listing[]; next?: string | null; previous?: string | null }

async function getPage(url: string) {
  const { data } = await api.get<ListingsPage>(url)
  return data
}

/**
 * Fetch store listings for a given person (by profile public_id).
 * Tries several parameter conventions for compatibility.
 */
export async function fetchListingsByPerson(publicId: string, cursor?: string | null): Promise<{ items: Listing[]; next_cursor: string | null }> {
  if (!publicId) return { items: [], next_cursor: null }

  // Cursor pagination
  if (cursor) {
    const { data } = await api.get<ListingsPage>(cursor)
    const results = Array.isArray((data as any)?.results) ? (data as any).results : []
    return { items: results, next_cursor: (data as any)?.next ?? null }
  }

  // Preferred: seller_public_id
  try {
    const { data } = await api.get<ListingsPage>(`/api/pixe_store/store/listings/`, { params: { seller_public_id: publicId } })
    const results = Array.isArray((data as any)?.results) ? (data as any).results : []
    return { items: results, next_cursor: (data as any)?.next ?? null }
  } catch (err: any) {
    if (![404, 405].includes(err?.response?.status)) throw err
  }

  // Alternate: profile_public_id
  try {
    const { data } = await api.get<ListingsPage>(`/api/pixe_store/store/listings/`, { params: { profile_public_id: publicId } })
    const results = Array.isArray((data as any)?.results) ? (data as any).results : []
    return { items: results, next_cursor: (data as any)?.next ?? null }
  } catch (err: any) {
    if (![404, 405].includes(err?.response?.status)) throw err
  }

  // Last attempt: nested people path (if provided by backend)
  try {
    const data = await getPage(`/api/people/i/${publicId}/listings/`)
    const results = Array.isArray((data as any)?.results) ? (data as any).results : []
    return { items: results, next_cursor: (data as any)?.next ?? null }
  } catch {
    return { items: [], next_cursor: null }
  }
}

